import React, { useContext, useEffect, useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import CarrierLogisticsCommonsContext from '@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsContext';
import CarrierLogisticsCommonsDispatchContext from '@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsDispatchContext';

import flattenObject from '../utils/flattenObject';
import {
  DEFAULT_LOCALE,
  flattenDefaultLocaleMessages,
  getTranslations,
} from '../config/i18n';
import {
  getLocaleFromLocalStorage,
  getSupportedLocaleForDeviceLocale,
} from '../utils/localeUtils';

/**
 * Wrap component with IntlProvider
 */
const withIntl = WrappedComponent => props => {
  const {
    localization: { locale = DEFAULT_LOCALE },
  } = useContext(CarrierLogisticsCommonsContext);
  const { localisationDispatch } = useContext(
    CarrierLogisticsCommonsDispatchContext
  );

  useEffect(() => {
    const localeFromLocaleStorage = getLocaleFromLocalStorage();
    if (localeFromLocaleStorage) {
      localisationDispatch?.dispatchStoreLocale(
        localeFromLocaleStorage.replace('_', '-')
      );
    } else if (window.navigator.language) {
      localisationDispatch?.dispatchStoreLocale(
        getSupportedLocaleForDeviceLocale()
      );
    }
  }, []);

  const messages = useMemo(
    () =>
      locale === DEFAULT_LOCALE
        ? flattenDefaultLocaleMessages
        : {
            ...flattenDefaultLocaleMessages,
            ...flattenObject(getTranslations(locale)),
          },
    [locale]
  );

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      defaultLocale={DEFAULT_LOCALE}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <WrappedComponent {...props} />
    </IntlProvider>
  );
};

export default withIntl;
